import React, { useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

import { useSiteData } from "../../Contexts/SiteContext";
import moment from "moment";
import { useEffect } from "react";
import Datepicker from "react-tailwindcss-datepicker";
import { notify } from "../../Datas/Functions/toast";
ChartJS.register(ArcElement, Tooltip, Legend);

const SellPieChart = () => {
  const { orderList } = useSiteData();
  const [showSellList, setShowSellList] = useState([]);
  const [dateRange, setDateRange] = useState({
    startDate: "2010-01-01",
    endDate: moment().format("YYYY-MM-DD"),
  });
  const getChartData = () => {
    const newSellList = orderList.reduce((res, ord) => {
      if (
        moment(dateRange.startDate) <= parseInt(ord.created_at) &&
        moment(dateRange.endDate) >= parseInt(ord.created_at)
      ) {
        if (!res[ord.product_name]) {
          res[ord.product_name] = {
            title: ord.product_name,
            profit: parseInt(ord.order_price),
            sellCount: 1,
          };
        } else {
          res[ord.product_name].sellCount++;
          res[ord.product_name].profit += parseInt(ord.order_price);
        }
      }
      return res;
    }, {});
    const newShowList = Object.entries(newSellList).map(
      ([heading, object]) => ({
        title: object.title + " - Sell " + object.sellCount,
        profit: object.profit,
      })
    );
    return newShowList;
  };
  useEffect(() => {
    const newdatalist = getChartData();
    if (newdatalist.length === 0) {
      notify("Sell not Found", "No Sell found in this Date Range", "error");
    } else {
      setShowSellList(newdatalist);
    }
  }, [dateRange, orderList]);
  return (
    <div className=" col-span-12 md:col-span-6">
      <div className="box bg-front dark:dark-bg-front dark:dark-text p-4">
        <h2 className="text-lg font-semibold mb-4">Sells in Date Range</h2>
        <Datepicker
          useRange={false}
          showFooter={true}
          placeholder={"Select a Date Range"}
          minDate={new Date("2010-01-01")}
          maxDate={new Date()}
          value={dateRange}
          onChange={(d) => setDateRange(d)}
          showShortcuts={true}
          displayFormat={"DD MMMM, YYYY"}
          containerClassName="relative border-2 rounded-md"
        />
        {showSellList.length > 0 ? (
          <div>
            <Pie
              data={{
                labels: showSellList.map((sell) => sell.title) || ["0"],
                datasets: [
                  {
                    label: "Profit in BDT ",
                    data: showSellList.map((sell) => sell.profit) || [0],
                    backgroundColor: [
                      "rgba(255, 99, 132, 0.2)",
                      "rgba(54, 162, 235, 0.2)",
                      "rgba(255, 206, 86, 0.2)",
                      "rgba(233, 192, 192, 0.2)",
                      "rgba(153, 102, 255, 0.2)",
                      "rgba(255, 159, 244, 0.2)",
                      "rgba(255, 206, 86, 0.2)",
                      "rgba(75, 244, 192, 0.2)",
                      "rgba(153, 102, 255, 0.2)",
                      "rgba(178, 58, 244, 0.2)",
                      "rgba(153, 102, 255, 0.2)",
                      "rgba(137, 199, 154, 1)",
                      "rgba(132, 206, 86, 0.2)",
                      "rgba(75, 154, 192, 0.2)",
                      "rgba(153, 165, 188, 0.2)",
                      "rgba(188, 58, 244, 0.2)",
                    ],
                    borderColor: [
                      "rgba(255, 99, 132, 1)",
                      "rgba(54, 162, 235, 1)",
                      "rgba(255, 206, 86, 1)",
                      "rgba(75, 192, 192, 1)",
                      "rgba(153, 102, 255, 1)",
                      "rgba(255, 159, 64, 1)",
                      "rgba(54, 162, 235, 1)",
                      "rgba(255, 253, 86, 1)",
                      "rgba(75, 142, 192, 1)",
                      "rgba(123, 32, 255, 1)",
                      "rgba(211, 159, 64, 1)",
                    ],
                    borderWidth: 1,
                  },
                ],
              }}
            />
          </div>
        ) : (
          <h1 className="my-5 text-center p-3 text-xl">
            Select Date range to Show Sells
          </h1>
        )}
      </div>
    </div>
  );
};

export default SellPieChart;
